const actions = {
  CLEAR_OCR_REDUX: 'CLEAR_OCR_REDUX',
  CLEAR_OCR_ERROR_MESSAGE: 'CLEAR_OCR_ERROR_MESSAGE',
  CLEAR_OCR_DATA: 'CLEAR_OCR_DATA',

  SEND_KTP_OCR_REQUEST: 'SEND_KTP_OCR_REQUEST',
  SEND_KTP_OCR_SUCCESS: 'SEND_KTP_OCR_SUCCESS',
  SEND_KTP_OCR_FAILURE: 'SEND_KTP_OCR_FAILURE',

  SEND_IMAGE_QUALITY_CHECK_REQUEST: 'SEND_IMAGE_QUALITY_CHECK_REQUEST',
  SEND_IMAGE_QUALITY_CHECK_SUCCESS: 'SEND_IMAGE_QUALITY_CHECK_SUCCESS',
  SEND_IMAGE_QUALITY_CHECK_FAILURE: 'SEND_IMAGE_QUALITY_CHECK_FAILURE',

  resetOCRData: payload => ({
    type: actions.CLEAR_OCR_REDUX,
    payload
  }),

  resetOCR: payload => ({
    type: actions.CLEAR_OCR_DATA,
    payload
  }),

  resetOCRErrorMessage: payload => ({
    type: actions.CLEAR_OCR_ERROR_MESSAGE,
    payload
  }),

  sendKTPOCR: payload => ({
    type: actions.SEND_KTP_OCR_REQUEST,
    payload
  }),
  sendImageQualityCheck: payload => ({
    type: actions.SEND_IMAGE_QUALITY_CHECK_REQUEST,
    payload
  })
}

export default actions
